import { render, staticRenderFns } from "./ClientAutocompleteItem.vue?vue&type=template&id=6b82e900&scoped=true&"
import script from "./ClientAutocompleteItem.vue?vue&type=script&lang=js&"
export * from "./ClientAutocompleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b82e900",
  null
  
)

export default component.exports